var _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPurina(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 757.14288,
    height: 148.57143,
    id: "svg45820",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", {
    id: "defs45822"
  }, /*#__PURE__*/React.createElement("clipPath", {
    id: "clipPath7319"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 275.418,350.079 L 316.798,350.079 L 316.798,342.691 L 275.418,342.691 L 275.418,350.079 z",
    id: "path7321"
  })))), /*#__PURE__*/React.createElement("g", {
    transform: "translate(360,-400.93362)",
    id: "layer1"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "matrix(17.47592,0,0,-17.47592,-5154.474,6529.8202)",
    id: "g7315"
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clipPath7319)",
    id: "g7317"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 275.418,342.691 L 316.798,342.691 L 316.798,350.079 L 275.418,350.079 L 275.418,342.691 z",
    id: "path7323",
    style: {
      fill: "#ffffff",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    }
  }))), /*#__PURE__*/React.createElement("path", {
    d: "M -211.41003,537.20488 L 378.38479,537.20488 L 378.38479,415.71061 L -211.41003,415.71061 L -211.41003,537.20488 z",
    id: "path7325",
    style: {
      fill: "#292526",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M -337.4988,537.20488 L -216.09358,537.20488 L -216.09358,415.71061 L -337.4988,415.71061 L -337.4988,537.20488 z",
    id: "path7327",
    style: {
      fill: "#ffffff",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M -333.65409,533.36018 L -219.93828,533.36018 L -219.93828,419.55699 L -333.65409,419.55699 L -333.65409,533.36018 z",
    id: "path7329",
    style: {
      fill: "#ffffff",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M -160.78229,444.84464 C -158.24828,444.26794 -156.09875,443.97085 -154.45601,443.97085 C -151.46763,443.97085 -148.79381,444.65241 -146.46951,445.99805 C -144.18017,447.32622 -142.38015,449.37091 -141.10441,452.0622 C -139.81119,454.82339 -139.16458,457.8642 -139.16458,461.09725 C -139.16458,465.72837 -140.51023,469.55559 -143.16657,472.4566 C -145.84038,475.3576 -148.91614,476.75567 -152.56861,476.75567 C -153.61717,476.75567 -154.92786,476.66829 -156.43079,476.49354 C -157.70653,476.31878 -159.19198,476.07411 -160.78229,475.7945 L -160.78229,444.84464 z M -138.71021,439.33973 C -142.852,437.85428 -148.54915,437.08534 -155.6269,437.08534 L -185.38839,437.08534 L -185.38839,441.45432 L -181.3165,441.45432 C -178.67764,441.45432 -176.77276,442.17083 -175.47954,443.62133 C -175.00769,444.18056 -174.22128,445.99805 -174.22128,452.07967 L -174.22128,502.9346 C -174.22128,508.47447 -174.81546,510.25701 -175.18245,510.83372 C -176.38829,512.65121 -178.39802,513.54249 -181.3165,513.54249 L -185.38839,513.54249 L -185.38839,517.92894 L -149.63266,517.92894 L -149.63266,513.54249 L -153.72202,513.54249 C -156.34341,513.54249 -158.23081,512.84345 -159.45412,511.39295 C -159.96093,510.83372 -160.78229,508.99875 -160.78229,502.9346 L -160.78229,481.4567 C -158.82499,481.87612 -156.88516,482.20816 -155.05019,482.45282 C -152.81327,482.73244 -150.71616,482.87225 -148.81129,482.87225 C -140.8947,482.87225 -134.65579,480.74018 -130.25186,476.51101 C -125.84793,472.28184 -123.62849,466.7245 -123.62849,460.01374 C -123.62849,455.05058 -125.09646,450.6816 -128.01494,447.04661 C -130.89847,443.44657 -134.49851,440.86013 -138.71021,439.33973",
    id: "path7331",
    style: {
      fill: "#ffffff",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M -46.192686,436.61349 L -47.311144,436.61349 L -47.311144,440.98247 L -43.274207,440.98247 C -40.652819,440.98247 -38.747944,441.6815 -37.472201,443.14948 C -36.982876,443.70871 -36.144032,445.57863 -36.144032,451.60782 L -36.144032,483.36157 C -36.144032,491.50535 -36.87802,497.30736 -38.29357,500.64526 C -39.674167,503.8783 -42.330507,506.58707 -46.157734,508.70166 C -50.019912,510.83372 -54.493748,511.91722 -59.439433,511.91722 C -63.266659,511.91722 -66.534656,511.23566 -69.121093,509.89002 C -71.707529,508.56185 -73.699784,506.86668 -75.062905,504.83948 C -76.443503,502.79479 -77.404679,499.85884 -77.928956,496.10152 C -78.488186,492.25681 -78.767801,488.77911 -78.767801,485.79072 L -78.767801,451.60782 C -78.767801,446.43495 -78.103716,444.37279 -77.544486,443.55143 C -76.391075,441.82131 -74.468724,440.98247 -71.672577,440.98247 L -67.600688,440.98247 L -67.600688,436.61349 L -103.35642,436.61349 L -103.35642,440.98247 L -99.33696,440.98247 C -96.78547,440.98247 -94.9505,441.6116 -93.866995,442.85239 C -93.098055,443.72618 -92.189307,445.9631 -92.189307,451.60782 L -92.189307,482.27806 C -92.189307,491.95972 -91.560174,498.40834 -90.266956,501.9909 C -88.344605,507.2162 -85.02418,511.4279 -80.393061,514.52114 C -75.779418,517.61437 -69.016237,519.16973 -60.243325,519.16973 C -52.186926,519.16973 -45.685884,517.54447 -40.932434,514.3289 C -36.178983,511.11333 -32.945938,507.16377 -31.303202,502.62004 C -29.695417,498.18115 -28.891525,491.9073 -28.891525,483.95575 L -28.891525,452.18453 C -28.891525,446.73204 -28.262392,444.96698 -27.877921,444.39027 C -26.42742,442.08345 -24.435165,440.98247 -21.761349,440.98247 L -17.724412,440.98247 L -17.724412,436.61349 L -18.842871,436.61349",
    id: "path7333",
    style: {
      fill: "#ffffff",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 31.662538,444.72231 C 34.913059,444.09318 37.586875,443.76114 39.526702,443.76114 C 44.192773,443.76114 47.985048,445.19416 50.798671,448.02526 C 53.62977,450.89131 55.027843,454.5263 55.027843,459.15742 C 55.027843,463.85844 53.297727,467.63324 49.767591,470.67405 C 46.237456,473.71486 40.837396,475.27022 33.742173,475.27022 C 33.445082,475.27022 33.060612,475.25274 32.466431,475.23527 C 32.25672,475.23527 31.977105,475.21779 31.662538,475.21779 L 31.662538,444.72231 z M 76.488273,510.44925 C 73.971741,508.82399 70.861027,505.43366 67.260987,500.38312 C 67.243511,500.36564 55.447265,484.06061 51.952081,479.21978 C 57.946322,477.64695 62.525013,475.14789 65.548347,471.74008 C 68.868772,468.00024 70.563936,463.50893 70.563936,458.42343 C 70.563936,453.65251 69.078483,449.47576 66.160004,446.01553 C 63.276478,442.60773 59.71139,440.231 55.552121,438.95526 C 51.497707,437.69699 45.1889,437.06786 36.782983,437.06786 L 7.0739187,437.06786 L 7.0739187,441.43684 L 11.110856,441.43684 C 13.74972,441.43684 15.63712,442.15335 16.912862,443.60385 C 17.419663,444.16308 18.241032,445.99805 18.241032,452.0622 L 18.241032,502.91713 C 18.241032,508.43952 17.594423,510.22206 17.227428,510.79877 C 16.02159,512.63374 14.029335,513.52501 11.110856,513.52501 L 7.0739187,513.52501 L 7.0739187,517.89399 L 42.829651,517.89399 L 42.829651,513.52501 L 38.670382,513.52501 C 36.083946,513.52501 34.231498,512.82597 32.990708,511.37547 C 32.483906,510.81624 31.662538,508.98127 31.662538,502.91713 L 31.662538,481.17708 C 31.854773,481.19456 32.064484,481.21203 32.25672,481.21203 C 32.763521,481.22951 33.305275,481.22951 33.864504,481.22951 C 34.982963,481.22951 36.381037,481.19456 37.988821,481.14213 L 64.342509,517.43962 L 64.674551,517.89399 L 87.445675,517.89399 L 87.445675,513.64734 L 86.432072,513.54249 C 82.342706,513.08811 79.004806,512.05703 76.488273,510.44925",
    id: "path7335",
    style: {
      fill: "#ffffff",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 111.54497,437.10281 L 110.42651,437.10281 L 110.42651,441.47179 L 114.30616,441.47179 C 115.9489,441.47179 117.53921,441.89121 119.05961,442.73006 C 120.00331,443.27181 120.63245,443.91842 120.91206,444.65241 C 121.22663,445.42135 121.59362,447.3437 121.59362,452.09715 L 121.59362,502.9346 C 121.59362,508.75408 120.85963,510.60653 120.42274,511.18324 C 119.19942,512.77355 117.18969,513.55996 114.30616,513.55996 L 110.42651,513.55996 L 110.42651,517.92894 L 146.18224,517.92894 L 146.18224,513.55996 L 142.25016,513.55996 C 140.6249,513.55996 139.05207,513.14054 137.58409,512.31917 C 136.60544,511.75994 135.95883,511.11333 135.67921,510.39682 C 135.36465,509.62788 135.01513,507.68805 135.01513,502.9346 L 135.01513,452.09715 C 135.01513,446.27767 135.76659,444.4427 136.20349,443.86599 C 137.44428,442.25821 139.41906,441.47179 142.25016,441.47179 L 146.18224,441.47179 L 146.18224,437.10281 L 145.04631,437.10281",
    id: "path7337",
    style: {
      fill: "#ffffff",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 263.53305,440.33586 L 263.53305,437.08534 L 233.92884,437.08534 L 233.92884,441.45432 L 237.79102,441.45432 C 240.53473,441.45432 242.54447,442.15335 243.7503,443.53395 C 244.25711,444.09318 245.09595,445.92815 245.09595,451.88744 L 245.09595,493.98693 L 198.62748,437.50476 L 198.29544,437.08534 L 175.3146,437.08534 L 175.3146,441.45432 L 176.45054,441.45432 C 178.60007,441.45432 180.20786,441.62907 181.20399,441.94364 C 183.35352,442.64268 184.97878,443.39414 186.07977,444.18056 C 187.09337,444.93202 188.70116,446.59224 190.78079,449.03886 L 190.78079,503.12684 C 190.78079,508.61428 190.11671,510.4143 189.69728,511.00848 C 188.5264,512.72112 186.48171,513.54249 183.47586,513.54249 L 179.61368,513.54249 L 179.61368,517.91147 L 209.21789,517.91147 L 209.21789,513.54249 L 205.30328,513.54249 C 202.57704,513.54249 200.56731,512.84345 199.32652,511.46285 C 198.85467,510.9211 198.05077,509.1036 198.05077,503.12684 L 198.05077,457.82925 L 248.31152,518.78526 L 248.64356,519.18721 L 252.34846,519.18721 L 252.34846,451.88744 C 252.34846,446.4 253.03002,444.59998 253.43196,444.0058 C 254.62033,442.29316 256.63006,441.45432 259.60096,441.45432 L 263.53305,441.45432",
    id: "path7339",
    style: {
      fill: "#ffffff",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 315.55886,457.30497 L 326.90073,485.02178 L 303.51795,485.02178 L 315.55886,457.30497 z M 360.64673,513.52501 C 357.71078,513.35025 355.42143,512.56383 353.83112,511.16576 C 352.15344,509.71526 350.23108,506.41231 348.13397,501.34429 L 321.37834,436.03678 L 321.08125,435.33774 L 317.25402,435.33774 L 316.95693,436.0193 L 288.85565,500.5404 C 286.53136,506.11522 284.41677,509.82011 282.56432,511.56771 C 282.10995,512.0046 280.7643,512.84345 276.77979,513.54249 L 275.85357,513.71724 L 275.85357,517.89399 L 302.76649,517.89399 L 302.76649,513.61239 L 301.71793,513.52501 C 297.314,513.21044 295.60136,512.52888 294.95475,512.0046 C 294.08095,511.32304 293.66153,510.57158 293.66153,509.71526 C 293.66153,508.78904 293.99357,506.91911 295.54893,503.31907 C 295.54893,503.31907 299.49849,494.24907 300.59947,491.71506 L 329.64445,491.71506 C 330.64058,494.14421 333.99595,502.32294 333.99595,502.34042 C 335.48141,505.81813 336.23287,508.36961 336.23287,509.89002 C 336.23287,510.79877 335.83093,511.56771 334.99208,512.23179 C 334.38043,512.72112 332.8775,513.36773 329.31241,513.52501 L 328.2289,513.57744 L 328.2289,517.89399 L 361.71276,517.89399 L 361.71276,513.59491",
    id: "path7341",
    style: {
      fill: "#ffffff",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M -337.4988,537.20488 L -216.09358,537.20488 L -216.09358,415.71061 L -337.4988,415.71061 L -337.4988,537.20488 z",
    id: "path7343",
    style: {
      fill: "#ed2232",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M -333.39196,532.87085 L -220.67227,532.87085 L -220.67227,420.04631 L -333.39196,420.04631 L -333.39196,532.87085 z",
    id: "path7345",
    style: {
      fill: "#ffffff",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M -328.81326,459.10499 L -294.14104,459.10499 L -294.14104,424.39782 L -328.81326,424.39782 L -328.81326,459.10499 z",
    id: "path7347",
    style: {
      fill: "#ed2232",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M -259.45134,459.10499 L -224.76164,459.10499 L -224.76164,424.39782 L -259.45134,424.39782 L -259.45134,459.10499 z",
    id: "path7349",
    style: {
      fill: "#ed2232",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M -294.14104,493.81217 L -259.45134,493.81217 L -259.45134,459.10332 L -294.14104,459.10332 L -294.14104,493.81217 z",
    id: "path7351",
    style: {
      fill: "#ed2232",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M -328.81326,528.53682 L -294.14104,528.53682 L -294.14104,493.81217 L -328.81326,493.81217 L -328.81326,528.53682 z",
    id: "path7353",
    style: {
      fill: "#ed2232",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M -259.45134,528.53682 L -224.76164,528.53682 L -224.76164,493.81217 L -259.45134,493.81217 L -259.45134,528.53682 z",
    id: "path7355",
    style: {
      fill: "#ed2232",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    }
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPurina);
export default __webpack_public_path__ + "static/media/purina.9e72e4a57379545a54d6ee5221180341.svg";
export { ForwardRef as ReactComponent };